import {Component, OnInit, OnDestroy, OnChanges} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute, RouterEvent, Event} from '@angular/router';
import {filter, tap, map, startWith} from 'rxjs/operators';
import {Subscription} from 'rxjs';

type NavigationMode = 'app' | 'portal';

@Component({
    selector: 'tfsport-secondary-navigation',
    templateUrl: './secondary-navigation.component.html',
    styleUrls: ['./secondary-navigation.component.scss'],
    standalone: false
})
export class SecondaryNavigationComponent implements OnInit, OnDestroy {
  public constructor(private router: Router) {}

  mode: NavigationMode;

  private sub: Subscription;

  ngOnInit() {
    this.sub = this.router.events
      .pipe(filter((ev: Event): ev is NavigationEnd => ev instanceof NavigationEnd))
      .pipe(map((ev: NavigationEnd) => ev.url))
      .pipe(startWith(this.router.url))
      .subscribe(url => {
        this.mode = SecondaryNavigationComponent.isAppRoute(url) ? 'app' : 'portal';
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  static isAppRoute(url: string) {
    //TODO: Do something smart with router data or whatever
    return ['/misc/appimprint', '/misc/appprivacypolicy'].includes(url);
  }
}
